 
import { Select, type SelectProps } from "antd";
import type { RefSelectProps } from "antd/es/select";
import { forwardRef, memo, useId, type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface CustomSelectProps extends SelectProps {
  label?: ReactNode;
  customLabel?: ReactNode;
  labelClassName?: string;
  containerClassName?: string;
}

const CustomSelect = forwardRef<RefSelectProps, CustomSelectProps>(
  (
    {
      label,
      customLabel,
      labelClassName,
      containerClassName = "",
      className,
      children,
      id,
      ...restProps
    },
    ref,
  ) => {
    const renderedLabel = customLabel ?? label;
    const generatedId = useId();
    const selectId = id ?? generatedId;
    const containerClasses = twMerge("flex flex-col common-cross-icon-class", containerClassName);
    const mergedLabelClass = twMerge(
      "block text-sm mb-2 text-gray9",
      labelClassName,
    );
    const mergedSelectClassName = twMerge("custom-select w-full", className);

    return (
      <div className={containerClasses}>
        {renderedLabel ? (
          <label className={mergedLabelClass} htmlFor={selectId}>
            {renderedLabel}
          </label>
        ) : null}

        <Select
          ref={ref}
          className={mergedSelectClassName}
          id={selectId}
          {...restProps}
        >
          {children}
        </Select>
      </div>
    );
  },
);

CustomSelect.displayName = "CustomSelect";

export default memo(CustomSelect);
